<template lang="pug">
  .print-competitors
    button.print-version(v-b-modal.print-competitors @click="printCompetitors")
      .fas.fa-print.mr-2
      | {{ $t("competitors_page.print") }}

    div(v-if="!this.comparisonMode")
      b-modal#print-competitors(hide-header hide-footer v-if="!isCountLessThanLowerEdge")
        .safe-radius(v-if="isSafeCount")
          .message-text
            | {{ $t('competitors_page.print_confirmation_text') }}
          .actions
            button.btn-outline-primary.cancel(@click="cancel") {{ $t('competitors_page.cancel') }}
            button.btn-outline-primary.print(@click="print") {{ $t('competitors_page.print') }}
        .unsafe-radius(v-if="isUnsafeCount")
          .message-text
           | {{ $t('competitors_page.impossible_print_text', { count: higherEdge }) }}
          .actions
            button.btn-outline-primary.ok(@click="cancel") {{ $t('competitors_page.ok') }}
</template>

<script>
  export default {
    props: {
      competitorsCount: {
        type: Number,
        default: 0
      },
      comparisonMode: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        lowerEdge: 4000,
        higherEdge: 6000
      }
    },

    computed: {
      isSafeCount() {
        return this.competitorsCount > this.lowerEdge && this.competitorsCount <= this.higherEdge 
      },

      isUnsafeCount() {
        return this.competitorsCount > this.higherEdge && !this.comparisonMode
      },

      isCountLessThanLowerEdge() {
        return this.competitorsCount <= this.lowerEdge && !this.comparisonMode
      }
    },

    methods: {
      printCompetitors() {
        if (this.isCountLessThanLowerEdge || this.comparisonMode) {
          this.confirmPrint()
        }
      },

      print() {
        this.$bvModal.hide('print-competitors')
        this.confirmPrint()
      },

      cancel() {
        this.$bvModal.hide('print-competitors')
      },

      confirmPrint() {
        this.$emit('printCompetitor')
      }
    }
  }
</script>

<style lang="scss" scoped>
.print-version {
  background-color: transparent;
  border: 0;
  color: #008bd0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0;
  text-decoration: none;

  .fas {
    color: #313541;
    font-size: 18px;
  }
}

.message-text {
  margin: 10px 0 30px 0;
}

.actions {
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
}

.cancel,
.ok {
  background: transparent;
  border: 1px solid rgba(0, 156, 234, 0.3);
  border-radius: 4px;
  color: #009cea;
  margin-right: 20px;
  padding: 5px 20px;
}

.print {
  background-image: linear-gradient(90deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
  border-color: transparent !important;
  border-radius: 4px;
  color: #fff;
  padding: 5px 20px;
}
</style>
